import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import { format, parseISO } from 'date-fns';

import styles from './TimeLineArrow.module.css';

interface Props {
  date_start: string;
  date_end?: string;
  animate: 'visible' | '';
}

const arrow = {
  initial: {
    opacity: 0,
    y: -5,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
    },
  },
};

export default function TimeLineArrow({ date_start, date_end = 'Present', animate }: Props) {
  return (
    <div className={styles.wrap}>
      <span className={styles.date}>
        {`${format(parseISO(date_start), 'dd.MM.yyyy')} – ${date_end === 'Present' ? date_end : format(parseISO(date_end), 'dd.MM.yyyy')}`}
      </span>
      <div className={styles.iconWrapper}>
        <motion.div
          className={styles.roundBg}
          initial="initial"
          variants={arrow}
          animate={animate || 'initial'}
        >
          <FontAwesomeIcon className={styles.faIcon} icon={faLocationDot as IconProp} />
        </motion.div>
      </div>
    </div>
  );
}
